import React, { useContext, useState } from "react"

const DeckContext = React.createContext(null)

function findViolations(deck, config) {
  const { regalia, main, side } = deck
  const violations = []
  if (regalia.length !== 12) {
    violations.push({ msg: "Regalia: invalid card count." })
  }
  if (main.length < 60) {
    violations.push({ msg: "MainDeck: invalid card count" })
  }
  if (side.length > 8) {
    violations.push({ msg: "SideDeck: invalid card count." })
  }
  return violations
}

export const DeckContextProvider = ({ children }) => {
  const [expanded, setExpanded] = useState(false)
  const [deck, setDeck] = useState({
    main: {
      /*
        [slug]: {
            count: 2
            data: {},
        }
        */
    },
    regalia: {},
    side: {},
  })

  /**
   *
   * @param {*} card
   * @param {"regalia" | "main" | "side"} section
   */
  const getSectionCount = (card, section) => {
    return deck?.[section]?.[card.slug]?.count ?? 0
  }

  const getTotalCount = (card) => {
    return (
      getSectionCount(card, "regalia") +
      getSectionCount(card, "main") +
      getSectionCount(card, "side")
    )
  }

  /**
   *
   * @param {*} card
   * @param {"regalia" | "main" | "side"} section
   */
  const increaseInSection = (card, section) => {
    setDeck({
      ...deck,
      [section]: {
        [card.slug]: {
          data: card,
          count: getSectionCount(card, section) + 1,
        },
      },
    })
  }

  /**
   *
   * @param {*} card
   * @param {"regalia" | "main" | "side"} section
   */
  const reduceInSection = (card, section) => {
    if (getSectionCount(card, section) === 1) {
      delete deck[section][card.slug]
    } else {
      setDeck({
        ...deck,
        [section]: {
          [card.slug]: {
            data: card,
            count: getSectionCount(card, section) - 1,
          },
        },
      })
    }
  }

  return (
    <DeckContext.Provider
      value={{
        deck,
        violations: findViolations(deck),
        increaseInSection,
        reduceInSection,
        getSectionCount,
        getTotalCount,
        expanded,
        setExpanded,
      }}
    >
      {children}
    </DeckContext.Provider>
  )
}

export const useDeckContext = () => {
  const value = useContext(DeckContext)
  if (!value) {
    throw new Error("called useDeckContext")
  }
  return value
}
